import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import WalletTwoToneSvg from "@ant-design/icons-svg/es/asn/WalletTwoTone";
import AntdIcon from "../components/AntdIcon";
var WalletTwoTone = function WalletTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: WalletTwoToneSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  WalletTwoTone.displayName = 'WalletTwoTone';
}
export default /*#__PURE__*/React.forwardRef(WalletTwoTone);